import { FC } from 'react'
//evertel
import {Icon, Button } from '../'

interface DownloadButtonProps {
    onDownload?: () => void
}

export const DownloadButton: FC<DownloadButtonProps> = ({
    onDownload,
    ...otherProps
}) => {

    const handleDownload = () => {
        if (onDownload) {
            onDownload()
        }
    }

    return (
        <Button
            onClick={() => handleDownload()}
            size="sm"
            {...otherProps}
            className="download-btn"
            color="ghost-muted"
        >
            <Icon
                name="cloud-arrow-down"
            />
        </Button>
    )
}
